Ext.define('SA.view.sidebar.data.DataSidebarHeader', {
    alias: 'widget.data-sidebar-header',
    extend: 'SA.view.sidebar.SectionHeader',

    html: [
        '<div class="sa-data-sidebar-header-container">',
            '<div class="sa-data-sidebar-header-slider">',
                '<span class="sa-data-sidebar-header-browse-by">Browse by </span>',
                '<button data-browse-by="category" class="sa-data-sidebar-header-link sa-data-sidebar-header-link-active">Category</button>',
                ' or ',
                '<button data-browse-by="dataFolder" class="sa-data-sidebar-header-link">Data Folder</button>',
                '<span class="sa-data-sidebar-header-year-wrap sa-data-sidebar-header-year-wrap-hidden">',
                    'Year: ',
                    '<button class="sa-sidebar-section-header-button">',
                        '<span class="sa-sidebar-section-header-button-text"></span>',
                    '</button>',
                '</span>',
            '</div>',
        '</div>'
    ],

    handler(ev) {
        var el;

        if (el = ev.getTarget('.sa-data-sidebar-header-link:not(.sa-data-sidebar-header-link-active)')) {
            this.onLinkClick(el);
        }
        else if (el = ev.getTarget('.sa-sidebar-section-header-button')) {
            this.onYearClick(el);
        }
    },

    onBoxReady() {
        this.callParent();

        this.yearTextEl = this.el.down('.sa-sidebar-section-header-button-text');
    },

    onLinkClick(el) {
        var browseBy = el.getAttribute('data-browse-by'),
            browseByCategory = browseBy === 'category';

        if (browseByCategory) {
            this.slideRight();
        }
        else {
            this.slideLeft();
        }

        this.el.down('[data-browse-by="category"]').ifCls(browseByCategory, 'sa-data-sidebar-header-link-active');
        this.el.down('[data-browse-by="dataFolder"]').ifCls(!browseByCategory, 'sa-data-sidebar-header-link-active');

        this.fireEvent('change:browseBy', browseByCategory);
    },

    onYearClick(el) {
        var me = this,
            menu = this.lastMenu;

        if (menu && menu.wasRecentlyVisible()) {
            return;
        }

        Ext.fly(el).addCls('sa-sidebar-section-header-button-active');

        menu = this.lastMenu = Ext.widget({
            xtype: 'menu',
            plugins: [{ptype: 'sa-arrow', target: el}],
            track: true,

            items: this.editionOptions.map(editionOption => {
                return {
                    text: editionOption.getYearOrText(this.latestEditionMenuItemText),

                    handler: () => {
                        if (this.hasSingleOption()) {
                            return;
                        }

                        me.fireEvent('change:editionOption', editionOption);
                    }
                };
            })
        });

        menu.on('hide', () => {
            menu.destroy();
            Ext.fly(el).removeCls('sa-sidebar-section-header-button-active');
        });

        menu.showBy(el, 'tl-bl?', [0, 7]);
    },

    hasSingleOption() {
        return this.editionOptions.length === 1;
    },

    setEditionOption(editionOption) {
        this.yearTextEl.setHTML(editionOption.getYearOrText('Latest'));
    },

    setEditionOptions(editionOptions) {
        this.editionOptions = editionOptions;
    },

    setLatestEditionMenuItemText(latestEditionMenuItemText) {
        this.latestEditionMenuItemText = latestEditionMenuItemText;
    },

    slideLeft() {
        var browseBy = this.el.down('.sa-data-sidebar-header-browse-by'),
            slider = this.el.down('.sa-data-sidebar-header-slider'),
            yearWrap = this.el.down('.sa-data-sidebar-header-year-wrap');

        slider.setLeft(-browseBy.getWidth());
        yearWrap.removeCls('sa-data-sidebar-header-year-wrap-hidden');
    },

    slideRight() {
        var slider = this.el.down('.sa-data-sidebar-header-slider'),
            yearWrap = this.el.down('.sa-data-sidebar-header-year-wrap');

        yearWrap.addCls('sa-data-sidebar-header-year-wrap-hidden');
        slider.setLeft(0);
    }
});